import { currentPriceFieldName, ascDirection } from '@/helpers/search-client/orderByNames';
import { EnumType } from 'json-to-graphql-query';
import { listing } from '@/helpers/search-client/fields';

export default () => ({
  maxPages: 0, // max pages calculated on request of vehicles from elastic search
  searchCriteria: {}, // search criteria to be used when querying elastic search
  defaultCriteria: {}, // the default critera picked from the context object
  sectionCustomQuery: {}, // section specific critera picked from the context object
  enabledFilters: [], // enabled filters on the given page to get filter counts
  isSearchLoading: false, // the loading state of the search
  isInitSearchLoading: false, // the initial search loading state used to reduce API calls
  currentPage: 1, // the active page the user is on
  pageSize: 12, // the amount of vehicles to show per page
  foundVehiclesCount: 0, // the total amount of vehicles found in elastic search
  offerVehicles: [], // offer vehicles available
  listingItems: [], // the results to show from elastic search
  filtersOptions: {}, // the filter options returned from elastic search
  coordinates: {
    lat: null,
    lon: null,
  },
  version: '1.0.0',
  location: '',
  context: {
    site: { // the site specific stock scope
      stockScope: {
        defaultValues: [],
        sectionCustomQuery: [],
        siteCustomQuery: [],
        type: '',
        values: [],
        usedFinanceDefaults: {
          payment: [150, 10000],
          annualMileage: '10000',
          deposit: '2000',
          depositType: 'cash',
          term: '48',
          product: '',
        },
        newFinanceDefaults: [],
      },
      gfSearchApi: {
        apiUrl: '',
        clientToken: '',
        uuid: '',
      },
    },
  },
  fields: listing, // the fields to be used to return in elastic search
  sortParams: [ // default sort values
    {
      fieldName: new EnumType(currentPriceFieldName),
      direction: new EnumType(ascDirection),
    },
  ],
  isUsingBrowserLocation: false,
});
